/**
 * @module LastBtn
 * @author Created by yanghongmei1
 * @date 2022/08/26
 */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { View, StyleSheet} from 'react-native';
import { pt } from '../../../../components/utiles';
import { JDText, JDTouchableWithoutFeedback } from '@jdreact/jdreact-core-lib';

export default class LastBtn extends PureComponent {
    static defaultProps = {
        name: 'LastBtn',
        customStyle: {},
        resetClick: () => {},
        confirmClick: () => {}
    }

    constructor(props) {
        super(props);
        this.state = {
        };
    }
    reset = () => {
        this.props.resetClick();
    }
    confirm = () => {
        this.props.confirmClick();
    }

    render() {
        const { customStyle } = this.props;
        return (
            <View style={[st.bottom, { paddingBottom: pt(41) }]}>
                <View style={st.bottomContainer}>
                    <JDTouchableWithoutFeedback
                        onPress={this.reset}
                    >
                        <View style={[st.btnReset, customStyle]}>
                            <JDText style={st.btnTextReset}>重置</JDText>
                        </View>
                    </JDTouchableWithoutFeedback>
                    <JDTouchableWithoutFeedback
                        onPress={this.confirm}
                        underlayColor='transparent'
                    >
                        <View style={[st.btnOk, customStyle]}>
                            <JDText style={st.btnTextOk}>确定</JDText>
                        </View>
                    </JDTouchableWithoutFeedback>
                </View>
            </View>
        );
    }

    componentDidMount() {
    }
}

LastBtn.propTypes = {
    name: PropTypes.string,
    customStyle: PropTypes.object,
    resetClick: PropTypes.func,
    confirmClick: PropTypes.func

};

const st = StyleSheet.create({
    bottom: {
        backgroundColor: '#ffffff',
        paddingTop: pt(16),
        paddingBottom: pt(41),
        paddingHorizontal: pt(32),
        width: '100%',
        zIndex: 11
    },
    bottomContainer: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundColor: 'white'
    },
    btnReset: {
        height: pt(76),
        borderRadius: pt(38),
        borderWidth: pt(1),
        borderColor: '#FA2C19',
        width: pt(200),
        alignItems: 'center',
        textAlignVertical: 'center'
    },
    btnOk: {
        position: 'relative',
        height: pt(76),
        width: pt(200),
        borderRadius: pt(38),
        borderWidth: pt(1),
        borderColor: '#FA2C19',
        alignItems: 'center',
        backgroundColor: '#FA2C19',
        overflow: 'hidden'
    },
    buttonBg: {
        position: 'absolute',
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        zIndex: 0
    },
    btnTextReset: {
        textAlign: 'center',
        color: '#FA2C19',
        fontSize: pt(28),
        lineHeight: pt(75)
    },
    btnTextOk: {
        position: 'relative',
        color: '#ffffff',
        fontSize: pt(28),
        lineHeight: pt(75),
        zIndex: 1
    },
    btnTextSmall: {
        color: '#ffffff',
        fontSize: pt(24)
    }
});
